import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../core/services/alert.service';
import { CommonService } from '../core/services/common.service';
import { DbService } from '../core/services/db.service';
import { PushService } from '../core/services/push.service';
import { Notifications } from '../models/notifications.model';
import { PushAlarms } from '../models/pushAlarms.model';

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: ['./push-modal.component.scss'],
})
export class PushModalComponent {
  @Input() uuids;
  @Input() type;
  content = '';

  pushAlarm: PushAlarms = {
    id: '',
    dateCreated: '',
    title: '',
    content: '',
    url: '',
    type: '',
    sendSwitch: false,
    expirationDate: '',
    uuid: '',
  };

  constructor(
    public modalService: NgbModal,
    private alertService: AlertService,
    private pushService: PushService,
    private commonService: CommonService,
    private db: DbService
  ) {}

  ngOnInit(): void {}

  // [전송하기]
  sendPush() {
    // 필수값 입력 누락 있는 경우
    if (!this.content) {
      this.alertService.errormsg(
        '입력되지 않은 내용이 있습니다. \n 확인 후 다시 시도해주세요.'
      );
      return;
    }

    // 필수값 모두 입력 시
    this.alertService
      .successConfirm(
        '선택하신 고객에게 푸시 알림을 전송하시겠습니까?\n탈퇴 인원에게는 전송되지 않습니다.',
        '전송하기'
      )
      .then(async (ok) => {
        if (ok) {
          // 알림 update
          this.uuids.forEach((uuid) => {
            let notification: Notifications = {
              id: this.commonService.generateFilename(),
              dateCreated: new Date().toISOString(),
              uuid: uuid,
              title: this.content,
              enTitle: '',
              readSwitch: false,
              url: '',
            };

            this.db.updateAt(`notifications/${notification.id}`, notification);
          });

          // 푸시 update
          this.pushAlarm.id = this.commonService.generateFilename();
          this.pushAlarm.dateCreated = new Date().toISOString();
          this.pushAlarm.title = '드림체인';
          this.pushAlarm.content = this.content;
          this.pushAlarm.url = '/tabs/home';
          this.pushAlarm.type = this.type;
          this.pushAlarm.sendSwitch = true;

          await this.db.updateAt(
            `pushAlarms/${this.pushAlarm.id}`,
            this.pushAlarm
          );

          let obj = {
            content: this.pushAlarm.content,
            link: this.pushAlarm.url,
            type: this.pushAlarm.type,
          };

          for await (let element of this.uuids) {
            this.pushService.memberPush(obj, element);
          }

          this.alertService.swalToast('전송 완료');
          this.modalService.dismissAll();
        }
      });
  }
}
